<template>
    <div :style="`min-width:${chartProdutividade.chartData.labels.length * 8}px;max-width:100%;`">
        <horizontalBar-chart :height="height" :chart-data="chartProdutividade.chartData" :extra-options="chartProdutividade.extraOptions">
        </horizontalBar-chart>
    </div>
</template>

<script>
import HorizontalBarChart from '@/components/Charts/HorizontalBarChart'
import defaultChartObjects from "../defaultChartObjects"
import { mapActions, mapGetters } from 'vuex'

export default {
    component: 'BarChartProdutividade',

    components: {
        HorizontalBarChart,
    },

    props: {
        height: {
            type: Number,
            default: 250
        },

        fetchProgress: {
            type: Number,
            default: 0 | 100
        },

        filteredDataCharts: {
            type: Array | Object,
            default: {} | []
        },

        defaultBarThickness: {
            type: Number,
            default: 8,
        },


        verticalChartMaxLines: {
            type: Number,
            default: 20,
        },
    },

    data: () => {
        return {
            maxBarThickness: 30,
        }
    },

    computed: {
        ...mapGetters('product', {
            useChartCache: "getUseChartCache",
            chartObject: "getBarChartProdutividade",
        }),

        chartProdutividade(){
            var defaultChart = {}
            defaultChart = JSON.parse(JSON.stringify(defaultChartObjects.defaultBarChartProdutividade))

            if(this.useChartCache == true && this.chartObject.chartData != undefined){
              defaultChart = JSON.parse(JSON.stringify(this.chartObject))
              if(this.fetchProgress < 100){
                sessionStorage.removeItem('SET_BAR_CHART_PRODUTIVIDADE_save')
              }
            }

            if(this.fetchProgress == 0 || this.fetchProgress == 100 && !sessionStorage.getItem('SET_BAR_CHART_PRODUTIVIDADE_save')){
                var dados = Object.values(this.filteredDataCharts).filter(function(value, index){ return !value.trafx && !value.finance && value.checkin.hasCheckin })
                var labels = this.groupBy(dados, val => val.checkin.list[0].operator).map(function (val, idx) { return val })
                var arrayInfo = new Array(labels.length).fill(0)

                labels.forEach(function (val, idx) {
                    var qntd = val[1].length
                    arrayInfo[idx] = { label: val[0], amount: qntd }
                })

                arrayInfo.sort(function (a, b) { return a.amount < b.amount ? -1 : a.amount > b.amount ? 1 : 0; })
                arrayInfo.reverse()

                defaultChart.chartData = {
                    labels: arrayInfo.slice(0, this.verticalChartMaxLines).map(function (val, idx) { return val.label }),      //NOMES DOS LABELS DO PERIODO
                    datasets: [{
                        label: 'Operadores',
                        data: arrayInfo.slice(0, this.verticalChartMaxLines).map(function (val, idx) { return val.amount }),              //VALOR DA QNTD DE CHECKINS POR OPERATOR
                        barThickness: this.defaultBarThickness,
                        maxBarThickness: this.maxBarThickness,
                        backgroundColor: this.colors,
                    }],
                }

                defaultChart.extraOptions = {
                    legend: { display: false },
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItem, data) { return Number(tooltipItem.value) + " check-ins"; }
                        }
                    },
                }

                // defaultChart.savedDate = new Date().toLocaleString()
                if(this.useChartCache == true && this.fetchProgress == 100 && !sessionStorage.getItem('SET_BAR_CHART_PRODUTIVIDADE_save')){
                  sessionStorage.setItem('SET_BAR_CHART_PRODUTIVIDADE_save','1')
                  this.productStoreCommit({ mutation:"SET_BAR_CHART_PRODUTIVIDADE", value: JSON.parse(JSON.stringify(defaultChart)) })
                }
            }
            return defaultChart
        },

    },

    methods:{
        ...mapActions('product',[
            "productStoreCommit",
        ]),

        //METHOD TO GROUP BY KEYGETTER.
        //KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
        groupBy(list, keyGetter) {
            const map = new Map();
            list.forEach((item) => {
                const key = keyGetter(item);
                const collection = map.get(key);

                if (!collection) { map.set(key, [item]); }
                else { collection.push(item); }
            });
            return Array.from(map);
        },
    }
}

</script>
